import { Home, SearchX } from "lucide-react";
import { Translate, useAuthenticated, useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Loading } from "@/components/admin/loading";

/**
 * Fallback page displayed when no route matches the current URL.
 *
 * Offers a next action back to the dashboard instead of a bare
 * browser-history back button, reusing the existing `ra.page.dashboard`
 * label ("Tablero") rather than adding a new one — no i18n message file is
 * touched here.
 */
export const NotFound = () => {
  const { isPending } = useAuthenticated();
  const translate = useTranslate();
  if (isPending) {
    return <Loading />;
  }
  return (
    <div className="flex min-h-[50vh] flex-1 flex-col items-center justify-center gap-2 text-center">
      <SearchX className="h-16 w-16 text-muted-foreground" />
      <h1 className="text-2xl font-semibold">
        <Translate i18nKey="ra.page.not_found" />
      </h1>
      <p className="max-w-xl text-muted-foreground">
        <Translate i18nKey="ra.message.not_found" />
      </p>
      <Button className="mt-3" asChild>
        <Link to="/">
          <Home />
          {translate("ra.page.dashboard")}
        </Link>
      </Button>
    </div>
  );
};
